import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { DUBAI_AREAS } from "@/lib/dubaiAreas";

export function DubaiAreaSelect({ value, onChange, testid = "area-select" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open} data-testid={testid} className="w-full justify-between rounded-lg font-normal">
          <span className={value ? "text-slate-800" : "text-slate-400"}>{value || "Select your Dubai community…"}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search Dubai communities…" data-testid={`${testid}-input`} />
          <CommandList>
            <CommandEmpty>No community found.</CommandEmpty>
            <CommandGroup>
              {DUBAI_AREAS.map((a) => (
                <CommandItem key={a} value={a} data-testid={`${testid}-option`} onSelect={() => { onChange(a); setOpen(false); }}>
                  <Check className={`mr-2 h-4 w-4 ${value === a ? "opacity-100" : "opacity-0"}`} />
                  {a}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
